// The difficulty ramp: totalCorrect → level → problem-generation bounds.
// Pure & tested so the ceiling is honest (the old in-game cap of 6 made the
// intended ×12 tables unreachable — 5 + 6 only ever hit 11).

export const MAX_LEVEL = 7;

export function levelFor(totalCorrect: number): number {
  return Math.min(MAX_LEVEL, Math.floor(totalCorrect / 5));
}

export interface DifficultyOpts {
  maxResult: number;
  maxFactor: number;
  optionCount: number;
}

export function problemOptsFor(level: number): DifficultyOpts {
  return {
    maxResult: Math.min(20, 9 + level * 2),
    maxFactor: Math.min(12, 5 + level), // times tables grow with level, up to ×12
    optionCount: level >= 3 ? 5 : 4,
  };
}
